import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

Alert.Title = AlertTitle

export default Alert
